import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveDashboard = ["dashboard"];

const DashboardIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveDashboard.some((item) =>
        item.includes(pathname.split("/")[1])
      ) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4158 15.5561C19.1557 16.1567 18.5373 16.5 17.8829 16.5H13.5808C13.609 16.4216 13.634 16.3413 13.6557 16.2592C13.9067 15.306 13.6423 14.3358 13.0363 13.655C13.26 11.8334 13.3996 9.96716 13.4849 8.49306C13.5272 7.7617 12.6312 7.51741 12.3085 8.17232C11.658 9.49232 10.8619 11.1795 10.1605 12.8709C9.30118 13.1522 8.59544 13.8579 8.34441 14.8111C8.19176 15.3908 8.22971 15.9767 8.41918 16.5H4.11716C3.46273 16.5 2.84435 16.1567 2.58428 15.5561C2.10115 14.4405 1.83337 13.2099 1.83337 11.9167C1.83337 6.85405 5.93743 2.75 11 2.75C16.0627 2.75 20.1667 6.85405 20.1667 11.9167C20.1667 13.2099 19.8989 14.4405 19.4158 15.5561Z"
            fill="#20A2A2"
          />
          <path
            d="M13.4849 8.4929C13.5272 7.76154 12.6312 7.51725 12.3085 8.17216C11.658 9.49216 10.8619 11.1793 10.1605 12.8708C9.30114 13.152 8.5954 13.8577 8.34437 14.8109C7.95135 16.3033 8.82177 17.8373 10.2884 18.2372C11.7551 18.6371 13.2627 17.7514 13.6556 16.259C13.9067 15.3058 13.6422 14.3356 13.0362 13.6548C13.26 11.8332 13.3996 9.96699 13.4849 8.4929Z"
            fill="white"
            stroke="#20A2A2"
            className="not_active stroke_active"
          />
          <ellipse cx="11" cy="15.5835" rx="1.375" ry="1.375" fill="#20A2A2" />
          <rect
            x="5.84698"
            y="8.68124"
            width="0.760833"
            height="1.55609"
            rx="0.380417"
            transform="rotate(-54.6036 5.84698 8.68124)"
            fill="white"
            stroke="white"
            stroke-width="0.760833"
          />
          <rect
            x="4.80807"
            y="12.9003"
            width="0.760833"
            height="1.6775"
            rx="0.380417"
            transform="rotate(-89.7167 4.80807 12.9003)"
            fill="white"
            stroke="white"
            stroke-width="0.760833"
          />
          <rect
            x="8.77054"
            y="5.77704"
            width="0.760833"
            height="1.42881"
            rx="0.380417"
            transform="rotate(-30.3652 8.77054 5.77704)"
            fill="white"
            stroke="white"
            stroke-width="0.760833"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4158 15.5561C19.1557 16.1567 18.5373 16.5 17.8829 16.5H13.5808C13.609 16.4216 13.634 16.3413 13.6557 16.2592C13.9067 15.306 13.6423 14.3358 13.0363 13.655C13.26 11.8334 13.3996 9.96716 13.4849 8.49306C13.5272 7.7617 12.6312 7.51741 12.3085 8.17232C11.658 9.49232 10.8619 11.1795 10.1605 12.8709C9.30118 13.1522 8.59544 13.8579 8.34441 14.8111C8.19176 15.3908 8.22971 15.9767 8.41918 16.5H4.11716C3.46273 16.5 2.84435 16.1567 2.58428 15.5561C2.10115 14.4405 1.83337 13.2099 1.83337 11.9167C1.83337 6.85405 5.93743 2.75 11 2.75C16.0627 2.75 20.1667 6.85405 20.1667 11.9167C20.1667 13.2099 19.8989 14.4405 19.4158 15.5561Z"
            stroke="#454F5B"
            stroke-width="1.2"
          />
          <path
            d="M13.4849 8.4929C13.5272 7.76154 12.6312 7.51725 12.3085 8.17216C11.658 9.49216 10.8619 11.1793 10.1605 12.8708C9.30114 13.152 8.5954 13.8577 8.34437 14.8109C7.95135 16.3033 8.82177 17.8373 10.2884 18.2372C11.7551 18.6371 13.2627 17.7514 13.6556 16.259C13.9067 15.3058 13.6422 14.3356 13.0362 13.6548C13.26 11.8332 13.3996 9.96699 13.4849 8.4929Z"
            fill="#454F5B"
          />
          <circle cx="11" cy="15.3083" r="2.29167" fill="#FEFEFE" />
          <ellipse cx="11" cy="15.3999" rx="1.375" ry="1.375" fill="#454F5B" />
          <rect
            x="5.8471"
            y="8.68124"
            width="0.760833"
            height="1.55609"
            rx="0.380417"
            transform="rotate(-54.6036 5.8471 8.68124)"
            fill="#454F5B"
            stroke="#454F5B"
            stroke-width="0.760833"
          />
          <rect
            x="4.80844"
            y="12.9003"
            width="0.760834"
            height="1.6775"
            rx="0.380417"
            transform="rotate(-89.7167 4.80844 12.9003)"
            fill="#454F5B"
            stroke="#454F5B"
            stroke-width="0.760834"
          />
          <rect
            x="8.77054"
            y="5.77704"
            width="0.760833"
            height="1.42881"
            rx="0.380417"
            transform="rotate(-30.3652 8.77054 5.77704)"
            fill="#454F5B"
            stroke="#454F5B"
            stroke-width="0.760833"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default DashboardIcon;
